<cmps-dialog class="cmps-cdk-h-100p cmps-cdk-overflow-hidden">
    <cmps-dialog-header [closeTooltip]="_i18n._11160_CLOSE_CHAT | translate">
        <div
            class="justify-content-between cmps-cdk-d-flex cmps-cdk-align-items-center"
        >
            <div
                class="flex-grow-1 cmps-cdk-pr-0dot5 minimize"
                (click)="_onMinMaxClick()"
            >
                <span
                    *ngIf="_service.state?.nav === _ChatNav.MENU"
                    class="header"
                    >{{ _i18n._11041_CHAT | translate }}</span
                >
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        _service.state?.minimized
                            ? (_i18n._11162_MAXIMIZE_CHAT | translate)
                            : (_i18n._11161_MINIMIZE_CHAT | translate)
                    "
                    trigger="hover"
                    (click)="_onMinMaxClick()"
                >
                    <cmps-icon
                        [svgIcon]="_service.state?.minimized ? 'plus' : 'minus'"
                    ></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <!-- same y/bottom padding as .cmps-dialog -->
    <cmps-dialog-body
        class="cmps-cdk-pb-1 cmps-cdk-h-100p cmps-cdk-overflow-hidden"
    >
        <ng-container *ngIf="!_service.state?.minimized">
            <ng-container [ngSwitch]="_service.state?.nav">
                <cmps-teamschat-summary
                    *ngSwitchCase="_ChatNav.MENU"
                ></cmps-teamschat-summary>
                <cmps-chat-box
                    *ngSwitchCase="_ChatNav.CHAT_BOX"
                    [data]="_service.state?.ctx?.chatBoxData"
                ></cmps-chat-box>
            </ng-container>
            <!--@deprecated temporary. keep for the time being-->
            <!-- <ng-container *ngFor="let r of _service.rows">
                <ng-container
                    *ngTemplateOutlet="
                        r.template;
                        context: { $implicit: r.context }
                    "
                ></ng-container>
            </ng-container> -->
        </ng-container>
    </cmps-dialog-body>
</cmps-dialog>
